var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("shedule.title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-col",
            { style: { display: "flex", flexDirection: "row" } },
            [
              _c("w-date-picker", {
                style: { flexGrow: "1", marginRight: "10px" },
                attrs: { fancy: "", label: _vm.$ct("shedule.date") },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
              _c("w-input-time", {
                style: { minWidth: "120px" },
                attrs: { fancy: "", label: _vm.$ct("shedule.time"), step: 900 },
                model: {
                  value: _vm.time,
                  callback: function ($$v) {
                    _vm.time = $$v
                  },
                  expression: "time",
                },
              }),
            ],
            1
          ),
          _vm.linkedEvent
            ? _c(
                "w-col",
                { staticClass: "mt" },
                [
                  _c("w-fa", {
                    staticClass: "mrs",
                    attrs: { icon: "calendar-alt" },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$ct("shedule.already-in-calendar", {
                          calendar: _vm.linkedCalendarName,
                        })
                      ) +
                      " "
                  ),
                ],
                1
              )
            : [
                _c(
                  "w-col",
                  { staticClass: "mt" },
                  [
                    _c("w-checkbox", {
                      attrs: { label: _vm.$ct("shedule.add-to-calendar") },
                      model: {
                        value: _vm.addToCalendar,
                        callback: function ($$v) {
                          _vm.addToCalendar = $$v
                        },
                        expression: "addToCalendar",
                      },
                    }),
                  ],
                  1
                ),
                _vm.addToCalendar
                  ? _c(
                      "w-col",
                      {
                        staticClass: "mts",
                        style: { display: "flex", flexDirection: "row" },
                      },
                      [
                        _c("app-calendar-select", {
                          style: { flexGrow: "1", marginRight: "10px" },
                          attrs: {
                            fancy: "",
                            label: _vm.$ct("shedule.calendar"),
                          },
                          model: {
                            value: _vm.calendarId,
                            callback: function ($$v) {
                              _vm.calendarId = $$v
                            },
                            expression: "calendarId",
                          },
                        }),
                        _c("w-select", {
                          style: { minWidth: "120px" },
                          attrs: {
                            items: _vm.durationItems,
                            fancy: "",
                            label: _vm.$ct("shedule.duration"),
                          },
                          model: {
                            value: _vm.durationMinutes,
                            callback: function ($$v) {
                              _vm.durationMinutes = $$v
                            },
                            expression: "durationMinutes",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
        ],
        2
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "danger light",
              style: { marginRight: "10px" },
              on: {
                click: function ($event) {
                  return _vm.remove()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("shedule.remove")))]
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.saveDisabled },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("shedule.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }